import React from 'react'
import './ICSDateRange.css'
import { Control, Controller, useController } from 'react-hook-form'
import DateBox from 'devextreme-react/date-box'
import { Row } from 'reactstrap'
import { isAfter, isBefore } from 'date-fns'
import dayjs from 'dayjs'

interface ICSDateRangeProps {
  id?: string
  name: string
  control: Control<any>
  label?: string
}


const ICSDateRange: React.FC<ICSDateRangeProps>  = ({
  name,
  id = `${name}DateBox`,
  control,
  label = 'Date Range'
}) => {
  const {
      field: { value: startValue, onChange: startOnChange, ref: startRef },
      fieldState: { invalid: startInvalid, error: startError, isTouched: startDateTouched, isDirty: startDateDirty }
    } = useController({
      name: `${name}.start`,
      control
    })

  const {
    field: { value: endValue, onChange: endOnChange, ref: endRef },
    fieldState: { invalid: endInvalid, error: endError, isTouched: endDateTouched, isDirty: endDateDirty }
  } = useController({
    name: `${name}.end`,
    control
  })

  return (
            <>
              <DateBox
                id={`${id}Start`}
                placeholder="Start Date"
                name={`${name}.start`}
                type='datetime'
                showClearButton={true}
                value={startValue}
                max={endValue ? endValue : undefined}
                isValid={!startInvalid}
                displayFormat='yyyy/MM/dd HH:mm:ss'
                onValueChanged={e => {
                  if (e.value === null) {
                    startOnChange(e.value)
                  } else {
                    startOnChange(dayjs(e.value).format('YYYY-MM-DDTHH:mm:ss'))
                  }
                }}
                className={
                  !(startDateTouched || startDateDirty)
                    ? ''
                    : !startInvalid
                    ? 'custom-valid-datebox'
                    : 'custom-invalid-datebox'
                }
                ref={startRef}
                acceptCustomValue={true}
              />
            
              <DateBox
                id={`${id}End`}
                placeholder="End Date"
                name={`${name}.end`}
                type='datetime'
                showClearButton={true}
                value={endValue}
                min={startValue ? startValue : undefined}
                isValid={!endInvalid}
                displayFormat='yyyy/MM/dd HH:mm:ss'
                onValueChanged={e => {
                  if (e.value === null) {
                    endOnChange(e.value)
                  } else {
                    endOnChange(dayjs(e.value).format('YYYY-MM-DDTHH:mm:ss'))
                  }
                }}
                className={
                  !(endDateTouched || endDateDirty)
                    ? ''
                    : !endInvalid
                    ? 'custom-valid-datebox'
                    : 'custom-invalid-datebox'
                }
                ref={endRef}
                acceptCustomValue={true}
              />
            </>
          )
}

export default ICSDateRange
